import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { SurveyQuestionTypeEnum } from 'src/app/enums/survey-question-type.enum';
import { SurveyVariableConditionSectionQuestionAnonymousScopeEnum } from 'src/app/enums/survey-variable-condition-section-question-anonymous-scope.enum';
import { SurveyVariableConditionSectionTypeEnum } from 'src/app/enums/survey-variable-condition-section-type.enum';
import type { SurveyFilter, SurveyFilterPayload } from 'src/app/models/survey.model';
import type { SurveyVariableConditionSectionQuestion } from 'src/app/models/survey-variable-condition-section-question.model';

export interface SurveyVariableConditionSection {
  id: number;
  survey_variable_condition_id: number;
  title: string;
  description: string | null;
  type: SurveyVariableConditionSectionTypeEnum;
  order: number;
  survey_variable_condition_section_questions_count?: number;
  survey_variable_condition_section_questions: SurveyVariableConditionSectionQuestion[];
  survey_variable_condition_filters?: SurveyFilter[];
  created_at: string;
  updated_at: string;
}

export interface SurveyVariableConditionSectionPayload {
  id?: number;
  title: string;
  description: string | null;
  type: SurveyVariableConditionSectionTypeEnum;
  order: number;
  filter: {
    role_ids: number[];
    department_category_ids: number[];
  };
}

export interface UpdateSurveyVariableConditionSectionBody {
  title: string;
  questions: UpdateSurveyVariableConditionSectionQuestionBody[];
  filter: SurveyFilterPayload;
}

export interface UpdateSurveyVariableConditionSectionQuestionItemBody {
  id: number | null;
  statement: string;
  description: string | null;
  order: number;
}

export interface UpdateSurveyVariableConditionSectionQuestionBody {
  id: number | null;
  statement: string;
  type: SurveyQuestionTypeEnum;
  min_characters: number | null;
  is_required: boolean;
  allows_dont_know: boolean;
  anonymous_scope: SurveyVariableConditionSectionQuestionAnonymousScopeEnum;
  items: UpdateSurveyVariableConditionSectionQuestionItemBody[];
}

export const MIN_CHARACTERS_MIN = 1;
export const MIN_CHARACTERS_MAX = 1000;

export interface SurveySectionTypePresentation {
  type: SurveyVariableConditionSectionTypeEnum;
  title: string;
  badge_label: string;
  description: string;
}

export type SurveySectionQuestionItemForm = FormGroup<{
  id: FormControl<number | null>;
  statement: FormControl<string>;
  description: FormControl<string | null>;
  order: FormControl<number>;
}>;

export type SurveySectionQuestionForm = FormGroup<{
  id: FormControl<number | null>;
  form_key: FormControl<number>;
  expanded: FormControl<boolean>;
  statement: FormControl<string>;
  type: FormControl<SurveyQuestionTypeEnum>;
  min_characters: FormControl<number | null>;
  is_required: FormControl<boolean>;
  allows_dont_know: FormControl<boolean>;
  anonymous_scope: FormControl<SurveyVariableConditionSectionQuestionAnonymousScopeEnum>;
  items: FormArray<SurveySectionQuestionItemForm>;
}>;
